export let baseUrl = "";
if (window.location.origin.indexOf('http://localhost') > -1) {
  // baseUrl = "https://xxy.52ym.vip"
} else {
  baseUrl = window.location.origin
}
//1688相关的API
export let alibabaUrl = "https://47.104.17.107";
// export let javaUrl = "http://127.0.0.1:8090/release_part";
export let javaUrl = "https://test.buyunxt.com/release_part";
// export const baseUrl = process.env.NODE_ENV == 'production' ? prodUrl : "/api/";
export const api = {
  "get_gjp_config": baseUrl + "/shop_api/gjp/get_gjp_config", // 获取管家婆数据接口
  "save_gjp_url": baseUrl + "/shop_api/gjp/save_gjp_url", // 保存管家婆数据接口
  "gjp_member_list": baseUrl + "/shop_api/gjp/gjp_member_list", // 管家婆会员列表
  "gjp_warehouse_list": baseUrl + "/shop_api/gjp/gjp_warehouse_list", // 管家婆仓库列表
  "gjp_get_refund_order_list": baseUrl + "/shop_api/gjp/gjp_refund_order_list", // 管家婆退款订单列表
  "gjp_order_push": baseUrl + "/shop_api/gjp/push_order_to_gjp", // 管家婆推送订单

  "save_gjp_config": baseUrl + "/shop_api/gjp/save_gjp_config", // 保存管家婆配置
  "get_gjp_pay_method": baseUrl + "/shop_api/gjp/get_gjp_pay_method", // 获取管家婆支付方式
  "save_gjp_config_match": baseUrl + "/shop_api/gjp/save_gjp_config_match", // 保存匹配组配置
  "gjp_status": baseUrl + "/shop_api/gjp/app_status",//获取管家婆订阅状态
  "get_gjp_config_match": baseUrl + "/shop_api/gjp/get_gjp_config_match", // 获取匹配组配置

  "get_gjp_job": javaUrl + "/shop_api/quartz_job/get_gjp_job", // 获取管家婆任务
  "stop_gjp_job": javaUrl + "/shop_api/quartz_job/pause_job/", // 停止管家婆任务
  "start_gjp_job": javaUrl + "/shop_api/quartz_job/resume_job/", // 运行管家婆任务
  "delete_gjp_job": javaUrl + "/shop_api/quartz_job/delete_job/", // 删除管家婆任务
  "create_gjp_job": javaUrl + "/shop_api/quartz_job/add", // 创建管家婆任务
  "productSave": javaUrl + "/shop_api/product/save", // 保存商品

  "batch_sku_image_upload": baseUrl + "/shop_api/product/batch_spu_image_upload", // 批量图片上传 

  "login": baseUrl + "/shop_api/shop_admin/login", // 登录
  "sendsms": baseUrl + "/shop_api/shop_admin/send_code", // 获取验证码
  "register": baseUrl + "/shop_api/shop_admin/register", // 注册
  "pwdUpdate": baseUrl + "/shop_api/shop_admin/set_password", // 修改密码
  "gainToken": baseUrl + "/shop_api/user/get_user_token", // 获取customToken
  "passwordFreeLogin": baseUrl + "/shop_api/shop_admin/password_free_login/",//自动登录
  "send_code_by_shop_admin": baseUrl + "/shop_api/shop_admin/send_code_by_shop_admin", // 管理员发送验证码
  "pwdUpdateByCode": baseUrl + "/shop_api/shop_admin/set_password_by_code", // 管理员通过验证码修改密码
  // 系统设置
  "configCate": baseUrl + "/shop_api/sys_config/class_list", // 获取配置分类
  "configList": baseUrl + "/shop_api/sys_config/config_list", // 获取配置
  "saveConfig": baseUrl + "/shop_api/sys_config/save_value", // 保存配置

  // 规格列表
  "skuList": baseUrl + "/shop_api/product/get_sku_list", // sku会员价格列表
  "addSku": baseUrl + "/shop_api/product/add_sku", // 添加sku会员价格
  "editSku": baseUrl + "/shop_api/product/update_sku_price", // 编辑sku会员价格
  "batchEditSku": baseUrl + "/shop_api/product/batch_update_sku_price", // 批量编辑sku会员价格
  "importSku": baseUrl + "/shop_api/product/import_sku", // 导入sku会员价格
  "delSku": baseUrl + "/shop_api/product/del_sku/", // 删除规格
  "levelList": baseUrl + "/shop_api/member_level/list", // 会员级别列表
  "whosaleRule": baseUrl + "/shop_api/wholesale_price/info", // 批发规则
  "oneRuleCreate": baseUrl + "/shop_api/wholesale_price/save", // 单个混批规则创建
  "moreRuleCreate": baseUrl + "/shop_api/wholesale_price/batch_save", // 多个混批规则创建
  "updateOhterInfo": baseUrl + "/shop_api/product/update_sku_info", // 修改商家编码条码

  //商品列表
  "syncDetail": baseUrl + "/shop_api/product/sync_pro_details/", // 同步单个商品详情
  "syncMoreDetail": baseUrl + "/shop_api/product/sync_batch_pro_details", // 批量同步商品详情
  "syncTemplate": baseUrl + "/shop_api/product/update_template/", // 设置单个运费模板
  "syncMoreTemplate": baseUrl + "/shop_api/product/update_batch_template", // 批量设置运费模板
  "selectTemplate": baseUrl + "/shop_api/freight_template/get_select_list", // 运费模板下拉列表
  "delSpu": baseUrl + "/shop_api/product/delete/", // 删除商品
  "editSpuStatus": baseUrl + "/shop_api/product/status/", // 修改商品上下架
  "batchDelete": baseUrl + "/shop_api/product/batchDelete",//batchDelete 批量删除
  "batchStatus": baseUrl + "/shop_api/product/batchStatus", //批量上下架
  "batchSort": baseUrl + "/shop_api/product/batch_sort", //批量权重
  "channelShop": baseUrl + "/shop_api/product/get_all_channel_shop", // 商品渠道
  "cancelSupplierProduct": baseUrl + "/shop_api/product/cancel_supplier_product", // 取消供应
  "mixedWholesale": baseUrl + "/shop_api/product/is_mixed_wholesale/", // 开启关闭混批
  "updateClassify": baseUrl + "/shop_api/product/update_classify", // 设置分类
  "classifySearch": baseUrl + "/shop_api/product/get_product_classify/", // 已设置分类
  "userList": baseUrl + "/shop_api/user/list", // 一客一价用户列表
  "editSinglePrice": baseUrl + "/shop_api/user_sku/edit", // 一客一价编辑
  "detailSinglePrice": baseUrl + "/shop_api/user_sku/list?product_id=", // 一客一价明细
  "deleteSinglePrice": baseUrl + "/shop_api/user_sku/delete", // 一客一价明细删除客户
  "cloneProduct": baseUrl + "/shop_api/product/clone_product_from_product", // 转为自营商品
  "setAssociated": baseUrl + "/shop_api/product/set_product_is_associated", // 设置商品关联开关
  "setSyncAssociatedSku": baseUrl + "/shop_api/product/set_product_is_sync_associated_sku/", // 设置商品关联同步开关
  "autoProductCloneSku": baseUrl + "/shop_api/product/auto_product_clone_sku", // 关联自动匹配
  "matchSkuList": baseUrl + "/shop_api/product/get_channel_sku_list/", // 关联商品sku列表
  "matchSkuSyncStock": baseUrl + "/shop_api/product/set_is_sync_associated_sku_stock", // 关联商品sku同步库存
  "setAssociatedSkuList": baseUrl + "/shop_api/product/get_match_sku_list", // 关联商品-手动匹配列表
  "setAssociatedSku": baseUrl + "/shop_api/product/set_associated_sku/", // 关联商品-手动匹配
  // "cancelAssociation": baseUrl + "/shop_api/product/cancel_association", // 取消关联
  "importOrder": baseUrl + "/shop_api/product/change_product_is_auto_agent_order", // 导入订单
  "batch_sku_image_upload": baseUrl + "/shop_api/product/batch_image_upload", // 批量上传sku图片
  "updateCartonSpec": baseUrl + "/shop_api/product/update_carton_spec", // 设置箱规

  // 自营订单管理
  "orderList": baseUrl + "/shop_api/order/get_order_list", // 订单列表
  "setPrice": baseUrl + "/shop_api/order/set_order_price", // 修改价格
  "sendGoods": baseUrl + "/shop_api/order/send_goods", // 发货
  "cancelOrder": baseUrl + "/shop_api/order/cancel/", // 取消订单
  "orderChannelShop": baseUrl + "/shop_api/order/get_all_channel_shop", // 订单渠道
  "convertAgentOrder": baseUrl + "/shop_api/order/convert_agent_order", // 转分销订单
  "flagMark": baseUrl + "/shop_api/order/update_order_mark", // 插旗备注
  "meOrderDetails": baseUrl + "/shop_api/order/get_details?order_no=", // 自营订单详情
  "platformSendGoods": baseUrl + "/shop_api/order/platform_send_goods/", // 平台物流信息上传
  "datashop": baseUrl + "/shop_api/order_dk/DK_get_product_info", // 获取商品详情
  "DK_get_sku_info": baseUrl + "/shop_api/order_dk/DK_get_sku_info", // 获取商品详情
  "DK_get_lastest_sku_info": baseUrl + "/shop_api/order_dk/DK_get_lastest_sku_info", // 获取商品最新库存

  'CreateOrder': baseUrl + "/shop_api/order_dk/DK_create_order", //提交代客订单
  "getShopAddress": baseUrl + "/shop_api/order_dk/DK_get_address_list", // 获取收货地址
  'shopFee': baseUrl + "/shop_api/order_dk/DK_confirm_order", // 获取代客运费
  'DK_address_create': baseUrl + '/shop_api/order_dk/DK_get_address_create', //创建收货地址
  "update_gift": baseUrl + "/shop_api/order/update_gift_status", // 审核赠品订单
  "Dk_pay": baseUrl + "/shop_api/order_dk/Dk_pay", // 代客支付

  // 自营订单售后
  "refundList": baseUrl + "/shop_api/refund/refund_list", // 订单售后列表
  "refundPass": baseUrl + "/shop_api/refund/refund_pass", // 同意
  "refundRefuse": baseUrl + "/shop_api/refund/refund_refuse", // 拒绝
  "selectList": baseUrl + "/shop_api/address/get_select_list", // 获取售后地址列表
  "returnAccepted": baseUrl + "/shop_api/refund/refund_goods_pass", // 同意退货
  "confirmReceipt": baseUrl + "/shop_api/refund/refund_confirm_receipt", // 确认收货
  "mesaleDetails": baseUrl + "/shop_api/refund/get_refund_details?refund_order_id=", // 自营售后订单详情
  "DK_refund": baseUrl + "/shop_api/order_dk/DK_refund", // 代客售后
  "DK_refund_list": baseUrl + "/shop_api/order_dk/DK_refund_list", // 代客售后列表
  "DKrefund": baseUrl + "/shop_api/order_dk/DK_refund", // 售后提交审核
  "DK_refund_edit": baseUrl + "/shop_api/order_dk/DK_refund_edit", // 代客售后删除
  "DK_get_details": baseUrl + "/shop_api/order_dk/DK_get_details", // 售后详情
  "DK_complete": baseUrl + "/shop_api/order_dk/DK_complete", // 售后完成
  "directReturnGoods": baseUrl + "/shop_api/refund/return_goods", // 直接退货退款
  "refundOrderd": baseUrl + "/shop_api/refund/refund", // 售后退款

  //分销订单管理
  "dxOrderList": baseUrl + "/shop_api/agent_order/get_order_list", // 订单列表
  "updateAddress": baseUrl + "/custom_api/order/update_receiver", // 修改地址
  "refundOrder": baseUrl + "/custom_api/refund/refund", // 售后
  "orderCancel": baseUrl + "/custom_api/order/cancel", // 订单撤销
  "dxChannelShop": baseUrl + "/shop_api/agent_order/get_all_channel_shop", // 订单渠道
  "morePayOrder": baseUrl + "/custom_api/order/batch_pay", // 批量支付

  //分销订单售后
  "dxRefundList": baseUrl + "/shop_api/agent_refund/refund_list", // 分销订单售后列表
  "returnGoods": baseUrl + "/custom_api/refund/return_goods", // 退货发货
  "dxshChannelShop": baseUrl + "/shop_api/agent_refund/get_all_channel_shop", // 订单渠道

  // 运费设置
  // "freightList": baseUrl + "/shop_api/postage/get_list", // 运费列表
  // "editFreight": baseUrl + "/shop_api/postage/save", // 编辑运费
  // "importFreight": baseUrl + "/shop_api/postage/import", // 运费导入
  // "exportFreight": baseUrl + "/shop_api/postage/export", // 运费导出

  // 运费模板
  "freightList": baseUrl + "/shop_api/freight_template/list", // 运费模板列表
  "deleteFreight": baseUrl + "/shop_api/freight_template/delete/", // 删除运费模板
  "addFreight": baseUrl + "/shop_api/freight_template/create", // 创建运费模板
  "editFreight": baseUrl + "/shop_api/freight_template/update/", // 编辑运费模板
  "freightInfo": baseUrl + "/shop_api/freight_template/info/", // 运费模板详情
  "free_shipping": baseUrl + "/shop_api/free_shipping/list", // 包邮设置列表
  "free_shipping_edit": baseUrl + "/shop_api/free_shipping/edit/",// 包邮设置编辑
  "free_shipping_create": baseUrl + "/shop_api/free_shipping/create",// 包邮设置创建
  "free_shipping_delete": baseUrl + "/shop_api/free_shipping/batchDelete",// 包邮设置删除

  // 商品和类目
  "syncGoods": baseUrl + "/shop_api/product/sync_pro", // 同步商品
  "cateList": baseUrl + "/shop_api/product/get_class", // 获取类目列表
  "cateList_costom": baseUrl + "/custom_api/product/get_class", // 获取类目列表custom
  "syncClassify": baseUrl + "/shop_api/product/sync_classify", // 同步类目
  "spuList": baseUrl + "/shop_api/product/get_product_list", // spu列表
  "goodsInfoSpu": baseUrl + "/shop_api/product/get_product_info/", // spu商品详情
  "goodsInfo": baseUrl + "/shop_api/product/get_sku_details", // sku商品详情
  "delCate": baseUrl + "/shop_api/classify/delete/", // 删除分类

  //用户列表
  "uList": baseUrl + "/shop_api/shop_user/list", // 用户列表
  "uEdit": baseUrl + "/shop_api/shop_user/edit/", // 用户编辑
  "freezeUser": baseUrl + "/shop_api/shop_user/suspend/", // 冻结用户
  "thawUser": baseUrl + "/shop_api/shop_user/unfreeze/", // 解冻用户
  "agreeUser": baseUrl + "/shop_api/shop_user/pass/", // 用户审核通过
  "noAgreeUser": baseUrl + "/shop_api/shop_user/refuse/", // 用户审核拒绝
  "loanLimit": baseUrl + "/shop_api/shop_user/set_loan_limit/", // 设置信用额
  "balance": baseUrl + "/shop_api/shop_user/set_balance/", // 设置余额
  "loanAmount": baseUrl + "/shop_api/shop_user/set_loan_amount/", // 设置欠款金额
  "billMark": baseUrl + "/shop_api/user_bill/update_mark/", // 设置备注
  "payBack": baseUrl + "/shop_api/shop_user/payback/", // 确认已还款
  "billList": baseUrl + "/shop_api/user_bill/list/", // 余额日志
  "importUser": baseUrl + "/shop_api/user/import", // 导入用户
  "userMark": baseUrl + "/shop_api/shop_user/update_mark/", // 用户备注
  "levelSelect": baseUrl + "/shop_api/member_level/list", // 会员级别下拉
  "editLevel": baseUrl + "/shop_api/member_level/edit", // 会员级别修改
  "delLevel": baseUrl + "/shop_api/member_level/delete/", // 会员级别删除
  "createLevel": baseUrl + "/shop_api/member_level/create", // 会员级别新增
  "bindTop": baseUrl + "/shop_api/shop_user/bind_shop_shop_admin", // 绑定经理和主管
  "listList": baseUrl + "/shop_api/shop_shop_admin/list_all?role_id=", // 获取经理和主管列表
  "refundSelectList": baseUrl + "/shop_api/refund/get_refund_order_status_select", // 售后状态下拉选
  "refundTypeList": baseUrl + "/shop_api/refund/get_refund_type_select", // 售后类型下拉选
  "addressUser": baseUrl + "/shop_api/address/list",// 用户收货地址列表
  "addressUserCreate": baseUrl + "/shop_api/address/create",//用户收货地址添加
  "addressUserDelete": baseUrl + "/shop_api/address/delete",//用户收货地址删除
  "addressUserEdit": baseUrl + "/shop_api/address/Edit",//用户收货地址编辑
  "toRecharge": baseUrl + "/shop_api/user_loan_recharge/create",//用户二维码还款  
  "addUser": baseUrl + "/shop_api/user/add",//用户添加

  // 地址管理
  "addressList": baseUrl + "/shop_api/address/list", // 地址列表
  "addressCreate": baseUrl + "/shop_api/address/create", // 地址新增
  "addressEdit": baseUrl + "/shop_api/address/edit", // 地址修改
  "addressDelete": baseUrl + "/shop_api/address/delete", // 地址删除
  "addressDetail": baseUrl + "/shop_api/address/detail", // 地址详情

  // 轮播图管理
  "bannerList": baseUrl + "/shop_api/banner/list", // 轮播列表
  "bannerCreate": baseUrl + "/shop_api/banner/create", // 轮播新增
  "bannerEdit": baseUrl + "/shop_api/banner/edit", // 轮播编辑
  "bannerDelete": baseUrl + "/shop_api/banner/delete", // 轮播删除

  // 首页分类设置
  "indexCateList": baseUrl + "/shop_api/classify/list", // 分类列表
  "indexCateChange": baseUrl + "/shop_api/classify/status/", // 首页分类开启关闭
  "indexCateEdit": baseUrl + "/shop_api/classify/edit", // 分类图标修改
  "shopInfo": baseUrl + "/shop_api/shop/info", // 店铺样式
  "shopUpdate": baseUrl + "/shop_api/shop/update", // 编辑店铺样式
  "shop_bind_refund_warehouse": baseUrl + "/shop_api/shop/bind_refund_warehouse", // 绑定总售后仓库

  // 店铺
  "shopCateList": baseUrl + "/shop_api/shop_cate/list", // 店铺分类列表
  "shopList": baseUrl + "/shop_api/shop/get_select", // 店铺列表
  "changeShop": baseUrl + "/shop_api/shop/change_shop/", // 切换店铺
  "createShop": baseUrl + "/shop_api/shop/create", // 创建店铺
  "sendOperateMobileCode": baseUrl + "/shop_api/shop/send_operate_mobile_code", // 运营人手机号验证码
  "getPlatformShopInfo": baseUrl + "/shop_api/shop/get_platform_shop_info/",


  //充值套餐
  "rechargeList": baseUrl + "/shop_api/recharge_package/list", // 充值套餐列表
  "rechargeCreate": baseUrl + "/shop_api/recharge_package/create", // 创建充值套餐
  "rechargeEdit": baseUrl + "/shop_api/recharge_package/edit/", // 编辑充值套餐
  "rechargeDelete": baseUrl + "/shop_api/recharge_package/delete/", // 删除充值套餐
  "rechargeChange": baseUrl + "/shop_api/recharge_package/status/", // 修改充值套餐状态

  //充值订单
  "rechargeOrderList": baseUrl + "/shop_api/user_recharge/list", // 充值订单列表
  "confirmOffline": baseUrl + "/shop_api/user_recharge/confirm_offline/", // 确认已支付
  "agreeApply": baseUrl + "/shop_api/user_recharge/borrow_pass/", // 同意借款申请
  "noAgreeApply": baseUrl + "/shop_api/user_recharge/borrow_refuses/", // 拒绝借款申请

  // 设置
  "shopConfig": baseUrl + "/shop_api/shop/get_config", // 商户配置
  "updateMini": baseUrl + "/shop_api/shop/update_mini_info", // 小程序配置更新
  "updateWechartPay": baseUrl + "/shop_api/shop/update_wechat_pay_info", // 微信支付配置更新
  "updateWechart": baseUrl + "/shop_api/shop/update_wechat_info", // 公众号配置更新
  "updateTemplate": baseUrl + "/shop_api/shop/update_wechat_template_info", // 订阅消息配置更新
  "authCode": baseUrl + "/shop_api/wechat_open/get_auth_code", // 获取授权码
  "update_tl_pay_info": baseUrl + "/shop_api/shop/update_tl_pay_info",//通联支付配置

  // 供应商
  "supplierList": baseUrl + "/shop_api/supplier/list", // 供应商
  "supplierAppliedList": baseUrl + "/shop_api/supplier/applied_list", // 供应商
  "supplierGoodsList_spu": baseUrl + "/shop_api/supplier_product/list", // 供应商商品列表-spu
  "supplierGoodsList_sku": baseUrl + "/shop_api/supplier_product/get_sku_list", // 供应商商品列表-sku
  "supplierApply": baseUrl + "/shop_api/supplier/apply", // 申请与供应商合作
  "resetSupplierApply": baseUrl + "/shop_api/supplier/re_apply", // 重新申请
  "supplierProducts": baseUrl + "/shop_api/supplier_product/batch_distribution_product", // 一键分销/整店分销
  "systemConfig": baseUrl + "/custom_api/sys_config/config_list", // 获取系统配置
  "xyOrderIds": baseUrl + "/custom_api/order/get_platform_order_list", // 闲鱼订单下拉列表
  "addressList_c": baseUrl + "/custom_api/address/list", // 地址列表
  "goodsInfoSpu_supplier": baseUrl + "/custom_api/product/get_product_info/", // 供应商商品详情spu
  "goodsInfoSku_supplier": baseUrl + "/custom_api/product/get_sku_details", // 供应商商品详情sku
  "confirmOrder": baseUrl + "/custom_api/order/confirm_order", // 确认订单
  "createOrder": baseUrl + "/custom_api/order/create_order", // 创建订单
  "orderPay": baseUrl + "/custom_api/order/pay", // 微盟支付
  "seizeSearch": baseUrl + "/custom_api/goofish_sync/good_seize", // 采集搜索
  "platformList": baseUrl + "/custom_api/goofish_sync/good_seize_platform", // 采集平台列表
  "importList": baseUrl + "/custom_api/goofish_config/list", // 导入列表
  "storeList": baseUrl + "/custom_api/goofish_sync/get_shop_list", // 商铺列表
  "bizList": baseUrl + "/custom_api/goofish_sync/get_biz_type", // 商品类型
  "spBizList": baseUrl + "/custom_api/goofish_sync/get_sp_biz_type", // 商品行业
  "channelCatIdList": baseUrl + "/custom_api/goofish_sync/get_product_category", // 商品类目
  "createDesc": baseUrl + "/custom_api/goofish_sync/gpt", // 生成gpt描述
  "addCar": baseUrl + "/custom_api/cart/add_cart", // 添加购物车
  "xyRelease": baseUrl + "/custom_api/goofish_sync/sync_product", // 发布到闲鱼
  "pollingPublish": baseUrl + "/custom_api/goofish_sync/polling_publish", // 同步商品结果轮询
  "carList": baseUrl + "/custom_api/cart/get_cart_list", // 购物车列表
  "delcarList": baseUrl + "/custom_api/cart/del_cart", // 删除购物车
  "setNums": baseUrl + "/custom_api/cart/set_nums", // 修改数量
  "setMealList": baseUrl + "/custom_api/recharge_package/list", // 套餐列表
  "createRechargeOrder": baseUrl + "/custom_api/user_recharge/create_order", // 创建充值支付订单
  "realtedList": baseUrl + "/custom_api/order/get_can_realted_order_list", // 获取有分销sku的自营订单
  "refundPrice": baseUrl + "/custom_api/refund/get_postage_price/", // 获取退款金额
  "updateSupplierConfig": baseUrl + "/shop_api/supplier/update_supplier_config", // 开启关闭自动售后
  "userBillList": baseUrl + "/custom_api/user_bill/list", // 某个用户余额日志
  "supplierConfig": baseUrl + "/shop_api/supplier/get_supplier_config?supplier_shop_id=", // 获取供应商配置
  "getDistributionConfig": baseUrl + "/shop_api/supplier/get_distribution_config", // 获取分销配置

  // 分销商
  "partnerList": baseUrl + "/shop_api/collaborator/list", // 分销商
  "setSupplierProduct": baseUrl + "/shop_api/supplier_product/set_supplier_product", // 一键供应/整店供应
  "cancelSupplier": baseUrl + "/shop_api/supplier_product/revoke_authorize_product", // 取消供应
  "createSupplier": baseUrl + "/shop_api/supplier/create", // 申请成为供应商
  "findbyShopId": baseUrl + "/shop_api/member_level_match/findbyShopId", // 根据店铺id查询分销商

  // 平台授权
  "authList": baseUrl + "/shop_api/platform_authorize/list", // 平台授权列表
  "urlList": baseUrl + "/shop_api/platform_authorize/get_type_list", // 新增授权店铺-列表
  "urlName": baseUrl + "/shop_api/platform_authorize/get_authorize_url", // 新增授权店铺-url查询
  "applyUnbind": baseUrl + "/shop_api/platform_authorize/un_bundle", // 申请解绑
  "matchList": baseUrl + "/shop_api/platform_sku/list/", // 商品匹配-列表
  "matchHand": baseUrl + "/shop_api/platform_sku/hand_matching_sku", // 商品匹配-手动匹配
  "matchSearchSku": baseUrl + "/shop_api/product/search_sku?keyword_accurate=", // 商品匹配-sku搜索
  "matchDownload": baseUrl + "/shop_api/platform_sku/download_sku/", // 商品匹配-下载商品
  "matchAuto": baseUrl + "/shop_api/platform_sku/auto_matching_sku/", // 商品匹配-自动匹配
  "matchSku": baseUrl + "/shop_api/platform_authorize/get_auth_sku_list/", // 商品匹配-sku列表
  "stockSnyc": baseUrl + "/shop_api/platform_authorize/set_sync_stock/", // 商品匹配-设置库存同步-开关
  "stockNotSnyc": baseUrl + "/shop_api/platform_authorize/set_not_need_sync_sku/", // 商品匹配-设置库存同步-提交
  "autoTurn": baseUrl + "/shop_api/platform_authorize/set_transfer_order/", // 商品匹配-设置自动转进货订单
  "orderSync": baseUrl + "/shop_api/platform_authorize/set_sync_order/", // 商品匹配-设置订单同步-订单下载开关
  "orderSyncMain": baseUrl + "/shop_api/platform_authorize/set_copy_order_to_main_store/", // 商品匹配-设置订单同步-转主店铺开关
  "orderSyncDown": baseUrl + "/shop_api/platform_authorize/download_order/", // 商品匹配-设置订单同步-下载订单
  "defaultShop": baseUrl + "/shop_api/platform_authorize/set_default_auth/", // 设置默认店铺
  "bindStoreList": baseUrl + "/shop_api/platform_authorize/get_organization_list/", // 获取绑定店铺列表
  "bindStore": baseUrl + "/shop_api/platform_authorize/bind_store/", // 绑定店铺
  "consumptionLog": baseUrl + "/shop_api/platform_authorize/get_auth_bill/", // 授权消费日志
  "chargeList": baseUrl + "/shop_api/platform_authorize/get_recharge_package", // 店铺充值菜单
  "createChargeOrder": baseUrl + "/shop_api/shop_recharge/create_order", // 创建点数充值订单
  "chargePay": baseUrl + "/shop_api/shop_recharge/pay", // 点数充值支付
  "expendLog": baseUrl + "/shop_api/shop/expend_log", // 店铺消费日志
  "smsRechargeList": baseUrl + "/shop_api/shop_recharge/sms_list", // 短信日志列表
  "authRenewal": baseUrl + "/shop_api/platform_authorize/auth_renewal/", // 续费
  "authBalanceRecharge": baseUrl + "/shop_api/platform_authorize/auth_balance_recharge/", // 平台充值余额
  "feeList": baseUrl + "/shop_api/platform_fee_apply/list", // 返款申请列表
  "backPlatformList": baseUrl + "/shop_api/platform_fee_apply/get_type_select", // 返款平台列表
  "feeCreate": baseUrl + "/shop_api/platform_fee_apply/create", // 返款创建
  "feeUpdate": baseUrl + "/shop_api/platform_fee_apply/update", // 返款编辑

  // 创建商品
  "storeInClassify": baseUrl + "/shop_api/classify/get_select_classify", // 店铺中分类
  "createProduct": baseUrl + "/shop_api/product/save", // 创建商品

  // 分类管理
  "cateManagementList": baseUrl + "/shop_api/classify/list", // 创建商品
  "createCateLevel": baseUrl + "/shop_api/classify/create", // 创建分类
  "editCateLevel": baseUrl + "/shop_api/classify/edit", // 编辑分类
  "dragSort": baseUrl + "/shop_api/classify/sort", // 拖拽排序
  "syncChannelClassify": baseUrl + "/shop_api/classify/sync_channel_classify", // 引用分类
  "isSyncClassToChannel": baseUrl + "/shop_api/classify/set_is_sync_class_to_channel", // 选择未默认同步

  // 批量铺货
  "spuInSkus": baseUrl + "/shop_api/product/get_products_sku", // 获取所选spu下的所有sku
  "threeFreightTemplate": baseUrl + "/shop_api/platform/get_freight_template", // 三方运费模板
  "threeFBigCate": baseUrl + "/shop_api/platform/get_item_cats", // 三方商品大分类
  "storeInnerCate": baseUrl + "/shop_api/platform/get_pshop_category", // 三方店铺中分类
  "imperfectionData": baseUrl + "/shop_api/platform/check_publish_pro_field", // 三方未完善数据
  "threePublish": baseUrl + "/shop_api/platform/create_product", // 三方商品发布
  "upDonwPackage": baseUrl + "/shop_api/platform/get_product_package", // 商品数据包
  "publishList": baseUrl + "/shop_api/publish/list", // 铺货日志
  "authShopList": baseUrl + "/shop_api/platform_authorize/get_select_list", // 已授权店铺列表
  "authShopInfoList": baseUrl + "/shop_api/publish/info/", // 授权日志详情列表
  "downCorrelation": baseUrl + "/shop_api/platform/get_product_relationship_excel?publish_product_log_id=", // 下载关联商品数据表

  // 首页
  'getAllList': baseUrl + '/shop_api/mini_ad/list',//商城动态列表
  "statisticsData": baseUrl + "/shop_api/dashboard/get_statistics_data", // 首页
  "get_qr_code": baseUrl + "/shop_api/wechat_open/get_qr_code", // 生成商品页面二维码

  // 账号管理
  "accountList": baseUrl + "/shop_api/shop_shop_admin/list", // 账号列表
  "allRole": baseUrl + "/shop_api/role/list_all", // 全部角色
  "accountEdit": baseUrl + "/shop_api/shop_shop_admin/update", // 账号编辑
  "accountAdd": baseUrl + "/shop_api/shop_shop_admin/create", // 账号新增
  "accountDel": baseUrl + "/shop_api/shop_shop_admin/delete", // 账号删除
  "change_shop_shop_admin_balance": baseUrl + "/shop_api/shop_shop_admin/change_shop_shop_admin_balance",//余额日志列表
  "get_shop_shop_admin_bill_list": baseUrl + "/shop_api/shop_shop_admin/get_shop_shop_admin_bill_list",//余额日志列表
  "get_shop_shop_admin_info_by_shop_admin_id": baseUrl + "/shop_api/shop_shop_admin/get_shop_shop_admin_info_by_shop_admin_id",//根据账号id获取账号详情

  // 角色管理
  "roleList": baseUrl + "/shop_api/role/list", // 角色列表
  "roleEdit": baseUrl + "/shop_api/role/update", // 角色编辑
  "roleAdd": baseUrl + "/shop_api/role/create", // 角色创建
  "roleDel": baseUrl + "/shop_api/role/delete", // 角色删除
  "haveRoleList": baseUrl + "/shop_api/role/get_edit_rule_ids?role_id=", // 已有权限列表
  "allRules": baseUrl + "/shop_api/rule/list_all?is_tree=1", // 所有权限列表

  // 权限
  "permissionList": baseUrl + "/shop_api/shop_shop_admin/get_rules", // 权限列表
  "ruleIds": baseUrl + "/shop_api/shop_shop_admin/get_rule_ids", // 获取当前帐号的权限ids
  "permissionDalete": baseUrl + "/shop_api/shop_shop_admin/delete_cache",//清除缓存
 


  //上传图片
  "upload_img": baseUrl + "/api/upload", // 上传图片
  "companyList": baseUrl + "/common_api/get_express_company_list", // 快递公司列表
  "getCategories": baseUrl + "/common_api/get_business_category", // 获取经营类目
  "tableExport": baseUrl + "/shop_api/export_data/export?table_name=", // 数据导出
  "templateExport": baseUrl + "/shop_api/export_data/export_template?type=", // 模板下载
  "expressInfo": baseUrl + "/common_api/search_express", // 物流信息
  "expressRefundInfo": baseUrl + "/common_api/refund_express", // 物流信息-售后
  "channelSelectList": baseUrl + "/common_api/get_all_channel_type_select_list/", // 获取通道类型下拉列表

  //应用列表
  "appList": baseUrl + "/shop_api/application/list",//获取应用列表
  "appdata": baseUrl + "/shop_api/application/info/",//获取应用详情
  "application_order": baseUrl + "/shop_api/application_pay/create_order",//购买应用
  "application_pay": baseUrl + "/shop_api/application_pay/pay",//应用支付
  "pay_list": baseUrl + "/shop_api/application_pay/list",//购买记录
  "get_trial": baseUrl + "/shop_api/application_pay/get_trial",//免费试用
  "pineapple": baseUrl + "/shop_api/pineapple/get_auth_config",//菠萝派应用获取url
  "pineapple_save": baseUrl + "/shop_api/pineapple/save_config",//菠萝派保存token

  //订单
  "alibabaFxOrderPreview": alibabaUrl + "/alibaba/order/fx_order_preview",//分销订单预览
  "alibabaFxOrderCreate": alibabaUrl + "/alibaba/order/fx_order_create",//分销订单创建
  "alibabaGrouppayUrl": alibabaUrl + "/alibaba/order/grouppay_url",//获取支付链接
  "alibabaFxOrderList": alibabaUrl + "/alibaba/order/list",//分销订单
  //order_buyer_view
  "alibabaFxOrderInfo": alibabaUrl + "/alibaba/order/info",//分销订单详情
  "logisticsBuyerView": alibabaUrl + "/alibaba/order/logistics_buyer_view",//分销订单详情
  "alibabaAuthToken": baseUrl + "/platform_api/alibaba/auth_token",//这边验证未登录的
  "alibabaCkeckShop": alibabaUrl + "/alibaba/check_shop",//这边验证已经登录的
  "alibabaProductInfo": alibabaUrl + "/alibaba/product/info",//内容详情
  "alibabaProductList": alibabaUrl + "/alibaba/product/list",//列表
  "alibabaCategory": alibabaUrl + "/alibaba/product/category",//分类
  "alibabaShopPlatform": alibabaUrl + "/alibaba/shop/platform",//阿里授权情况
  "alibabaProductCloneCheck": alibabaUrl + "/alibaba/product/clone_check",//阿里克隆前验证

  //吉客云配置
  "jackyun": baseUrl + "/shop_api/jackyun/index",//获取吉客云配置
  "jackyun_status": baseUrl + "/shop_api/jackyun/app_status",//获取吉客云订阅状态
  "jackyun_save": baseUrl + "/shop_api/jackyun/save_token",//保存token
  "get_warehouse": baseUrl + "/shop_api/jackyun/get_warehouse",//获取吉客云仓库
  "get_jky_user_list": baseUrl + "/shop_api/jackyun/get_jky_user_list?keyword=",//获取吉客云的用户列表
  "save_jackyun_config": baseUrl + "/shop_api/jackyun/save_jackyun_config",//保存表单配置
  "save_match_user": "/shop_api/jackyun/save_match_user",//吉客云保存用户
  "batch_pre_match_user": "/shop_api/jackyun/batch_pre_match_user",//用户列表模糊匹配
  "balance_with_code": "/shop_api/jackyun/get_jky_user_balance_with_code",//吉客云匹配余额
  "jky_user_balance": "/shop_api/jackyun/get_jky_user_balance",//吉客云余额匹配更新
  "jky_order_push": "/shop_api/jackyun/order/manual_push",//吉客云余额匹配更新
  "jky_bind_user": "/shop_api/jackyun/bind_user",//吉客云绑定员工


  //查号
  "category_list": baseUrl + "/shop_api/model_query_category/list",//查号列表
  "category_create": baseUrl + "/shop_api/model_query_category/create",//分类添加
  "category_edit": baseUrl + "/shop_api/model_query_category/edit",//分类编辑
  "category_delet": baseUrl + "/shop_api/model_query_category/delete/",//分类删除

  //首页目录
  "query_create": baseUrl + "/shop_api/model_query/create", //创建目录
  "query_list": baseUrl + "/shop_api/model_query/list", //目录
  "query_edit": baseUrl + "/shop_api/model_query/edit/",//目录编辑
  "query_batch_delete": baseUrl + "/shop_api/model_query/batch_delete",//目录批量删除
  "query_delet": baseUrl + "/shop_api/model_query/delete/",//目录编辑
  "query_import": baseUrl + "/shop_api/model_query/import", //目录导入
  "model_list": baseUrl + "/shop_api/model_query/model_list",//查号列表
  "bind_model": baseUrl + "/shop_api/model_query/bind_model",//绑定型号

  //满折满赠
  "gift_list": baseUrl + "/shop_api/order_gift_discount/list",
  "gift_create": baseUrl + "/shop_api/order_gift_discount/create",
  "gift_edit": baseUrl + "/shop_api/order_gift_discount/edit/",
  "gift_upStartEndTime": baseUrl + "/shop_api/order_gift_discount/upStartEndTime", //活动立即开始
  "gift_delete": baseUrl + "/shop_api/order_gift_discount/delete/",

  //云仓与共享仓
  "warehouse_status": baseUrl + "/shop_api/wms/warehouse/status",//状态更新
  "warehouse_list": baseUrl + "/shop_api/wms/warehouse/list",//列表
  "warehouse_save": baseUrl + "/shop_api/wms/warehouse/save",//添加/修改
  "warehouse_detail": baseUrl + "/shop_api/wms/warehouse/detail/",//详情
  "warehouse_type_list": baseUrl + "/shop_api/wms/warehouse/type_list",//仓库类型列表
  "warehouse_type_pos_switch": baseUrl + "/shop_api/wms/warehouse/pos_switch",//仓库货位开关
  "warehouse_stock_type_list": baseUrl + "/shop_api/wms/warehouse/stock_type_list",//仓库库存类型
  "warehouse_area_list": baseUrl + "/shop_api/wms/warehouse_area/list",//库区列表
  "warehouse_area_save": baseUrl + "/shop_api/wms/warehouse_area/save",//添加/修改
  "warehouse_area_detail": baseUrl + "/shop_api/wms/warehouse_area/detail/",//详情
  "warehouse_position_save": baseUrl + "/shop_api/wms/warehouse_position/save",//添加/修改
  "warehouse_position_list": baseUrl + "/shop_api/wms/warehouse_position/list",//列表
  "warehouse_position_detail": baseUrl + "/shop_api/wms/warehouse_position/detail/",//详情
  "warehouse_position_delete": baseUrl + "/shop_api/wms/warehouse_position/delete/",//删除库位
  "warehouse_stock_type_list": baseUrl + "/shop_api/wms/warehouse/stock_type_list",//库存类型
  "warehouse_update_config": baseUrl + "/shop_api/wms/warehouse/update_config",//更新配置
  "swms_user_manage_bind": baseUrl + "/shop_api/swms/user/manage_user/bind",//管理员绑定
  "swms_user_manage_unbind": baseUrl + "/shop_api/swms/user/manage_user/unbind",//管理员解除绑定
  "swms_user_warehouse_set_earnest_money": baseUrl + "/shop_api/swms/user/warehouse/set_earnest_money",//设置保证金
  "swms_user_check_earnest_money":baseUrl + "/shop_api/swms/user/warehouse/check_earnest_money",//检查保证金是否大于定金
  "swms_user_cost_price_update": baseUrl + "/shop_api/swms/user/cost_price/updata_cost_price",//更新成本价

  "wms_inout_type_list": baseUrl + "/shop_api/wms/inout/type_list",//单据类型列表
  "wms_inout_status_list": baseUrl + "/shop_api/wms/inout/status_list",//出入库状态列表
  "wms_inout_invoice_type_list": baseUrl + "/shop_api/wms/inout/invoice_type_list",//出入库单据类型列表
  "wms_inout_apply": baseUrl + "/shop_api/wms/inout/apply",//出入库申请
  "wms_inout_audit": baseUrl + "/shop_api/wms/inout/audit",//审核
  "wms_inout_sub_audit": baseUrl + "/shop_api/wms/inout/sub_audit",//提交审核
  "wms_inout_list": baseUrl + "/shop_api/wms/inout/list",//出入库单列表
  "wms_inout_detail": baseUrl + "/shop_api/wms/inout/detail",//单据明细
  "wms_inout_cancel": baseUrl + "/shop_api/wms/inout/cancel",//出入库单取消

  "wms_inout_work_submit": baseUrl + "/shop_api/wms/inout/work/submit",//提交作业
  "wms_inout_work_complete": baseUrl + "/shop_api/wms/inout/work/complete",//完成作业

  "wms_stock_list": baseUrl + "/shop_api/wms/stock/list",//仓库库存列表
  "wms_stock_log_list": baseUrl + "/shop_api/wms/stock/log_list",//库存日志
  "wms_stock_position_list": baseUrl + "/shop_api/wms/stock/position/list",//库位库存
  "wms_stock_change_type": baseUrl + "/shop_api/wms/stock/change_type",//日志-变更类型
  "wms_stock_shop_list": baseUrl + "/shop_api/wms/stock/shop_list",//整店库存列表
  "wms_serial_no_list": baseUrl + "/shop_api/wms/serial_no/list",//SN列表
  "wms_serial_no_active_list": baseUrl + "/shop_api/wms/serial_no/activate_list",//激活商品
  "wms_serial_no_outer_sku_codes": baseUrl + "/shop_api/wms/serial_no/outer_sku_codes",//SN列表-批量获取
  "wms_serial_no_log_list": baseUrl + "/shop_api/wms/serial_no/log_list",//SN日志
  "wms_serial_no_set_osc": baseUrl + "/shop_api/wms/serial_no/set_osc",//开启SN码管理
  "wms_serial_no_del_osc": baseUrl + "/shop_api/wms/serial_no/del_osc",//关闭SN码管理
  "wms_transfer_status_list": baseUrl + "/shop_api/wms/transfer/status_list",//调拨状态列表
  "wms_transfer_reason_list": baseUrl + "/shop_api/wms/transfer/reason_list",//调拨原因列表
  "wms_transfer_action_apply": baseUrl + "/shop_api/wms/transfer/action/apply",//快速调拨申请
  "wms_transfer_sub_audit": baseUrl + "/shop_api/wms/transfer/sub_audit",//调拨单提交审核
  "wms_transfer_audit": baseUrl + "/shop_api/wms/transfer/audit",//调拨单审核
  "wms_transfer_create_out": baseUrl + "/shop_api/wms/transfer/create_out",//废弃-调拨单出库
  "wms_transfer_create_inout": baseUrl + "/shop_api/wms/transfer/create_inout",//调拨单出入库单创建
  "wms_transfer_list": baseUrl + "/shop_api/wms/transfer/list",//调拨单列表
  "wms_transfer_detail": baseUrl + "/shop_api/wms/transfer/detail",//调拨单详情
  "wms_transfer_get_inout": baseUrl + "/shop_api/wms/transfer/get_inout",//调拨单入库详情

  "wms_stock_check_generate": baseUrl + "/shop_api/wms/stock/check/generate",//生成盘点单
  "wms_stock_check_detail": baseUrl + "/shop_api/wms/stock/check/detail",//盘点详情
  "wms_stock_check_work": baseUrl + "/shop_api/wms/stock/check/work",//盘点作业
  "wms_stock_check_finish": baseUrl + "/shop_api/wms/stock/check/finish",//盘点完成
  "wms_stock_check_list": baseUrl + "/shop_api/wms/stock/check/list",//盘点列表
  "wms_stock_check_work_detail": baseUrl + "/shop_api/wms/stock/check/work_detail",//盘点详情-作业明细
  "wms_stock_check_detail_list": baseUrl + "/shop_api/wms/stock/check/detail_list",//盘点明细列表
  "wms_stock_check_no_order": baseUrl + "/shop_api/wms/stock/check/no_order_check",//无单盘点
  "wms_stock_check_type_list": baseUrl + "/shop_api/wms/stock/check/check_type_list",//盘点类型
  "wms_stock_check_status_list": baseUrl + "/shop_api/wms/stock/check/status_list",//盘点状态
  "wms_stock_check_detail_sn_list": baseUrl + "/shop_api/wms/stock/check/detail_sn_list",//盘点明细 SN

  "wms_inout_share_in_confirm": baseUrl + "/shop_api/wms/inout/share_in_confirm",//共享仓入库确认

  "wms_stock_move": baseUrl + "/shop_api/wms/stock/move",//商品货位移动
  "wms_product_save": baseUrl + "/shop_api/wms/product/save",//商品发布
  "wms_goods_list": baseUrl + "/shop_api/wms/goods/list",//货品列表
  "wms_purchase_detail": baseUrl + "/shop_api/wms/goods/find_by_po",
  "wms_goods_scan": baseUrl + "/shop_api/wms/goods/scan",//货品扫码
  "swms_goods_get_outer_sku_codes": baseUrl + "/shop_api/wms/goods/get_outer_sku_codes",//仓库条码获取SKU信息
  "get_sn_info": baseUrl + "/shop_api/swms/serial_no/get_sn_info",//SN详细信息查询

  //收银台
  "add_member": baseUrl + "/shop_api/cash_register/shop_user_register", //会员注册
  "get_cashier_product": baseUrl + "/shop_api/cash_register/get_product_list", //获取收银台商品
  "shop_user_recharge": baseUrl + "/shop_api/cash_register/shop_user_recharge", //会员充值
  "get_cash_product_list": baseUrl + "/shop_api/cash_register/get_cash_product_list", //获取收银台商品
  "get_cash_sn_list": baseUrl + "/shop_api/cash_register/get_cash_sn_list", //获取收银台商品
  "change_cash_register_cart_nums": baseUrl + '/shop_api/cash_register_cart/change_nums', //修改购物车数量
  "add_cash_register_cart": baseUrl + '/shop_api/cash_register_cart/add_cart',//添加购物车
  "delete_cash_register_cart": baseUrl + '/shop_api/cash_register_cart/del_cart',//删除购物车
  "delete_all_cart": baseUrl + '/shop_api/cash_register_cart_order/del',//删除购物车
  "change_price": baseUrl + '/shop_api/cash_register_cart/change_price',//修改价格
  "get_cart_list": baseUrl + '/shop_api/cash_register_cart/get_cart_list',//获取购物车列表
  "change_cart": baseUrl + '/shop_api/cash_register_cart/change_cart',
  "change_final_price": baseUrl + "/shop_api/cash_register/set_order_price",
  "creat_orderid": baseUrl + "/shop_api/cash_register/create_order",
  "cash_register_pay": baseUrl + '/shop_api/cash_register/pay',
  "get_warehouse_list": baseUrl + '/shop_api/cash_register/get_warehouse_list',
  //  "get_cash_register_list":baseUrl+"/shop_api/cash_register_cart/get_cart_list",
  "cash_register_list": baseUrl + "/shop_api/cash_register/list",
  "cash_register_info": baseUrl + "/shop_api/cash_register/info", //收银台订单详情
  "cash_register_create": baseUrl + "/shop_api/cash_register/create", //收银台订单创建
  "select_manager": baseUrl + "/shop_api/shop_shop_admin/list",
  "change_warehouse_info": baseUrl + "/shop_api/cash_register/change", //修改仓库信
  "delivery_change": baseUrl + "/shop_api/cash_register/delivery_change",//修改配送
  "get_product_sku_list": baseUrl + "/shop_api/cash_register/get_product_sku_list",//获取商品SKU列表
  "print_cashier_desk_list": baseUrl + "/shop_api/print_cashier_desk/list",//获取收银台打印模板
  "print_cashier_desk_save": baseUrl + "/shop_api/print_cashier_desk/save",//收银台打印模板保存
  "cash_register_get_stock_info": baseUrl + "/shop_api/cash_register/get_stock_info_by_order_id",//收银台获取订单详情
  "cash_register_order_batch_out": baseUrl + "/shop_api/cash_register/order_batch_out",//收银台订单作业

  "wms_stock_move_no_order_move": baseUrl + "/shop_api/wms/stock/move/no_order_move",//无单商品货位移动
  "wms_stock_move_list": baseUrl + "/shop_api/wms/stock/move/list",//移库单列表
  "wms_stock_move_detail_list": baseUrl + "/shop_api/wms/stock/move/detail_list",//明细
  "wms_stock_move_generate": baseUrl + "/shop_api/wms/stock/move/generate",//货位移动-创建
  "wms_stock_move_work": baseUrl + "/shop_api/wms/stock/move/work",//货位移动-作业
  "wms_stock_move_finish": baseUrl + "/shop_api/wms/stock/move/finish",//货位移动-作业完成
  "wms_stock_move_status_list": baseUrl + "/shop_api/wms/stock/move/status_list",//货位移动-状态
  "wms_warehouse_total_data": baseUrl + "/shop_api/wms/warehouse/total_data",//仓库信息统计
  "wms_warehouse_sale_data": baseUrl + "/shop_api/wms/warehouse/warehouse_sale_data",//共享仓销售数据
  "wms_warehouse_status": baseUrl + "/shop_api/swms/app_state",//仓库应用状态
  "wms_warehouse_addSkuInfo": baseUrl + "/shop_api/wms/warehouse/add_sku_info",//仓库引入商品

  "swms_get_config": baseUrl + "/shop_api/swms/user/config/get_config",//获取个人共享仓配置
  "swms_set_config": baseUrl + "/shop_api/swms/user/config/set_config",//设置个人共享仓配置
  "swms_set_classify_pricing_list": baseUrl + "/shop_api/swms/user/config/classify_pricing_list",//分类定价列表
  "swms_save_classify_pricing": baseUrl + "/shop_api/swms/user/config/save_classify_pricing",//分类定价保存
  "swms_delete_classify_pricing": baseUrl + "/shop_api/swms/user/config/delete_classify_pricing",//分类定价删除
  "swms_user_warehouse_bind": baseUrl + "/shop_api/swms/user/warehouse/bind",//共享仓绑定
  "swms_user_warehouse_clear_bind": baseUrl + "/shop_api/swms/user/warehouse/clear_bind",//解除共享仓绑定
  "swms_user_warehouse_set_earnest_money": baseUrl + "/shop_api/swms/user/warehouse/set_earnest_money",//设置保证金
  "swms_user_pricing_list": baseUrl + "/shop_api/swms/user/config/classify_user_pricing_list",//用户定价列表
  "swms_user_pricing_save": baseUrl + "/shop_api/swms/user/config/save_classify_user_pricing",//用户定价保存
  "swms_user_pricing_delete": baseUrl + "/shop_api/swms/user/config/delete_classify_user_pricing",//用户定价删除
  "swms_user_list": baseUrl + "/shop_api/swms/user/config/classify_user_list",//用户定价商品SKU列表
  "swms_user_save": baseUrl + "/shop_api/swms/user/config/save_classify_user",//用户定价保存
  "swms_user_delete": baseUrl + "/shop_api/swms/user/config/delete_classify_user",//用户定价删除
  "swms_change_price": baseUrl + "/shop_api/wms/stock/price/change_price",//仓库调价单
  "swms_sku_price_list": baseUrl + "/shop_api/swms/user/config/sku_price_list",//商品定价列表
  "swms_sku_price_save": baseUrl + "/shop_api/swms/user/config/save_sku_price",//商品定价保存
  "swms_sku_price_delete": baseUrl + "/shop_api/swms/user/config/delete_sku_price",//商品定价删除
  "swms_sku_price_update": baseUrl + "/shop_api/swms/user/config/update_sku_price",//商品定价更新

  "swms_user_replenish_list": baseUrl + "/shop_api/swms/user/replenish/list",//补货单列表
  "swms_user_replenish_status_list": baseUrl + "/shop_api/swms/user/replenish/action/status_list",//补货单状态列表
  "swms_user_replenish_generate_type_list": baseUrl + "/shop_api/swms/user/replenish/action/generate_type_list",//补货单生成类型列表
  "swms_user_replenish_del": baseUrl + "/shop_api/swms/user/replenish/action/del",//删除补货单
  "swms_user_replenish_detail": baseUrl + "/shop_api/swms/user/replenish/detail",//补货单商品明细
  "swms_user_replenish_audit": baseUrl + "/shop_api/swms/user/replenish/action/audit",//补货单审核
  "swms_user_replenish_generate_details": baseUrl + "/shop_api/swms/user/replenish/action/generate_details",//预获取补货单详情
  "swms_user_replenish_update": baseUrl + "/shop_api/swms/user/replenish/action/update",//修改补货单货品
  "swms_user_replenish_generate": baseUrl + "/shop_api/swms/user/replenish/action/generate",//创建补货单
  "swms_user_replenish_batch_add": baseUrl + "/shop_api/swms/user/replenish/batch/add",//补货批次
  "swms_user_replenish_batch_classify_list": baseUrl + "/shop_api/swms/user/replenish/batch/classify_list",//补货批次类型
  "swms_user_replenish_batch_list": baseUrl + "/shop_api/swms/user/replenish/batch/list",//补货批次类型
  "swms_user_replenish_batch_detail": baseUrl + "/shop_api/swms/user/replenish/batch/detail",//补货批次详情
  "swms_user_replenish_sku_detail": baseUrl + "/shop_api/swms/user/replenish/sku_detail",//补货获取条码销售及库存
  "wms_warehouse_replenish_info_list": baseUrl + "/shop_api/swms/user/replenish/warehouse_replenish_info_list",//共享仓补货获取条码销售及库存
  "wms_set_plan_stock": baseUrl + "/shop_api/swms/user/replenish/set_plan_stock",//共享仓设置计划库存

  "wms_warehouse_third_type_list": baseUrl + "/shop_api/wms/warehouse/third_type_list",//共享仓第三方仓库类型
  "wms_warehouse_bind_third": baseUrl + "/shop_api/wms/warehouse/bind_third",//共享仓绑定第三方仓库

  "post_sales_reg_list": baseUrl + "/shop_api/post_sales_reg/list",//售后登记单列表
  "post_sales_reg_status": baseUrl + "/shop_api/post_sales_reg/status",//状态列表
  "post_sales_reg_detail": baseUrl + "/shop_api/post_sales_reg/detail",//详情
  "post_sales_reg_send_goods": baseUrl + "/shop_api/post_sales_reg/send_goods",//发货
  "post_sales_reg_complete": baseUrl + "/shop_api/post_sales_reg/transfer_complete",//售后登记仓调拨完成确认接口
  "post_sales_reg_create": baseUrl + "/shop_api/post_sales_reg/create_post_sales_order",//添加售后单
  "post_sales_reg_audit": baseUrl + "/shop_api/post_sales_reg/audit",//审核
  "post_sales_reg_examine": baseUrl + "/shop_api/post_sales_reg/examine_goods",//收货验货
  "post_sales_reg_create_by_user": baseUrl + "/shop_api/post_sales_reg/create_post_sales_order_by_user",//创建售后单
  "order_dk_create_wms_in": baseUrl + "/shop_api/order_dk/create_wms_in",//代客售后单入库
  "post_sales_reg_out_stock_out": baseUrl + "/shop_api/post_sales_reg/out/stock_out",//共享售后仓出库
  "post_sales_reg_out_send": baseUrl + "/shop_api/post_sales_reg/out/send",//共享售后仓出库发货修改
  "post_sales_reg_out_to_dk_refund": baseUrl + "/shop_api/post_sales_reg/out/to_dk_refund",//共享售后仓出库发货单转代客售后单
  "post_sales_reg_out_list": baseUrl + "/shop_api/post_sales_reg/out/list",//列表
  "post_sales_reg_out_status": baseUrl + "/shop_api/post_sales_reg/out/status",//状态
  "post_sales_reg_out_detail": baseUrl + "/shop_api/post_sales_reg/out/detail",//明细

  //消息队列
  "message_list": baseUrl + "/shop_api/shop_ad/list",
  "message_create": baseUrl + "/shop_api/shop_ad/create",
  "message_is_read": baseUrl + "/shop_api/shop_ad/is_read",
  "message_delete": baseUrl + "/shop_api/shop_ad/batch_delete",

  //结算账户
  "settlement_account_save": baseUrl + "/shop_api/finance/settlement_account/save",//结算账号添加修改
  "settlement_account_list": baseUrl + "/shop_api/finance/settlement_account/list",//结算账号列表
  "settlement_account_del": baseUrl + "/shop_api/finance/settlement_account/del",//结算账号删除
  "settlement_account_detail": baseUrl + "/shop_api/finance/settlement_account/detail",//结算账号明细详情
  "settlement_pay_type": baseUrl + "/shop_api/finance/settlement_account/pay_type",//结算账号类型
  "jky_bank_accounts_list_need": baseUrl + "/shop_api/jackyun/crm/bank_accounts_list_need",//吉客云结算用户列表
  "jky_customer_list": baseUrl + "/shop_api/jackyun/crm/customer_list",//吉客云客户列表
  "jky_bind_settlement_account": baseUrl + "/shop_api/jackyun/bind_settlement_account",//吉客云结算用户绑定/解绑
  "jackyun_import_customer": baseUrl + "/shop_api/jackyun/crm/import_customer",//批量会员导入吉客云
  "jackyun_cancel_bind": baseUrl + "/shop_api/jackyun/cancel_bind",//吉客云 用户解绑
  "jky_user_search": baseUrl + "/shop_api/jackyun/user_search",//吉客云 用户解绑

  "swms_rack_list": baseUrl + "/shop_api/swms/rack/list",//智慧仓列表
  "swms_rack_detail": baseUrl + "/shop_api/swms/rack/detail",//智慧仓详情
  "swms_rack_generate": baseUrl + "/shop_api/swms/rack/iot_rack/generate",//创建主从智能货柜
  "swms_rack_in_settle": baseUrl + "/shop_api/swms/rack/in/settle",//智慧仓结算
  "swms_rack_open": baseUrl + "/shop_api/swms/rack/open",//开启数据接收
  "swms_rack_close": baseUrl + "/shop_api/swms/rack/close",//关闭数据接收
  "swms_rack_stock_list": baseUrl + "/shop_api/swms/rack/stock/list",//货架库存
  "swms_rack_get_stock_status": baseUrl + "/shop_api/swms/rack/get_stock_status",//库位状态列表
  "swms_rack_stock_get_empty_positions": baseUrl + "/shop_api/swms/rack/stock/get_empty_positions",//货架空库位
  "swms_rack_in_create": baseUrl + "/shop_api/swms/rack/in/create",//智慧仓创建入库单
  "swms_rack_in_confirm": baseUrl + "/shop_api/swms/rack/in/confirm",//智慧仓确认入库
  "swms_rack_out_confirm": baseUrl + "/shop_api/swms/rack/out/confirm",//智慧仓确认出库
  "swms_rack_in_get_outer_sku_code": baseUrl + "/shop_api/swms/rack/in/get_outer_sku_code",//条码未结算库位
  "swms_rack_in_again_in": baseUrl + "/shop_api/swms/rack/in/again_in",//再次入库
  "swms_rack_in_get_history_position": baseUrl + "/shop_api/swms/rack/in/get_history_position",//条码历史库位信息
  "swms_user_order_list": baseUrl + "/shop_api/swms/user/order/list",//共享仓订单信息
  "swms_refund_refundByShareWarehouse": baseUrl + "/shop_api/refund/refundByShareWarehouse",//共享仓订单信息
  "swms_iot_transfer_app_init_cache": baseUrl + "/shop_api/swms/iot/transfer/app/init_cache",//更新中转站APP缓存
  "swms_iot_transfer_device_init_cache": baseUrl + "/shop_api/swms/iot/transfer/device/init_cache",//更新中转站设备缓存
  "swms_iot_transfer_device_status": baseUrl + "/shop_api/swms/iot/transfer/device/status",//更新获取设备状态
  "swms_iot_rack_move_generate": baseUrl + "/shop_api/swms/rack/move/generate",//智慧仓新建移库单
  "swms_iot_rack_move_finish": baseUrl + "/shop_api/swms/rack/move/finish",//智慧仓移库完成
  "swms_iot_rack_move_cancel": baseUrl + "/shop_api/swms/rack/move/cancel",//智慧仓取消移库
  "swms_iot_get_config": baseUrl + "/shop_api/swms/iot/config/get_config",//智慧仓获取配置
  "swms_iot_set_config": baseUrl + "/shop_api/swms/iot/config/set_config",//智慧仓保存配置
  "swms_iot_updateRackDevice": baseUrl + "/shop_api/swms/rack/iot_rack/updateRackDevice",//智慧仓修改绑定
  "swms_iot_updateRack": baseUrl + "/shop_api/swms/rack/iot_rack/updateRack",//智慧仓修改货柜名
  "swms_user_set_def_warehouse": baseUrl + "/shop_api/swms/user/warehouse/set_def_arehouse",//设置个人共享仓默认仓库
  "swms_iot_rack_add_device": baseUrl + "/shop_api/swms/rack/iot_rack/add_device",//添加主从设备
  "swms_iot_rack_change_status": baseUrl + "/shop_api/wms/warehouse_position/change_status",//更改库位状态
  "swms_iot_transfer_pollsata": baseUrl + "/shop_api/swms/iot/transfer/iot/pollsata",//拉取设备数据
  "swms_rack_in_detail_del": baseUrl + "/shop_api/swms/rack/in/detail/del",//删除智慧仓入库单库位
  "swms_rack_in_detail_add": baseUrl + "/shop_api/swms/rack/in/detail/add",//添加智慧仓入库单库位
  "swms_rack_in_detail_edit": baseUrl + "/shop_api/swms/rack/in/detail/edit",//调整智慧仓入库单库位
  "wms_in_detail_delete": baseUrl + "/shop_api/wms/in_detail/delete",//删除非智慧仓入库单库位
  "wms_in_detail_edit": baseUrl + "/shop_api/wms/in_detail/edit",//添加非智慧仓入库单库位
  "wms_in_detail_add": baseUrl + "/shop_api/wms/in_detail/add",//调整非智慧仓入库单库位
  
  // "print_spPrint_test": baseUrl + "/shop_api/spPrint/test",//商鹏 打印测试

  "swms_agent_order_confirm": baseUrl + "/shop_api/swms/shop/agent_order/confirm",//创建采购订单预览
  "swms_agent_order_create": baseUrl + "/shop_api/swms/shop/agent_order/create",//提交生成订单
  "swms_agent_order_get_order_goods": baseUrl + "/shop_api/swms/shop/agent_order/get_order_goods",//获取订单货品及SN
  "swms_agent_order_in": baseUrl + "/shop_api/swms/shop/agent_order/in",//入库
  "swms_agent_order_list": baseUrl + "/shop_api/swms/shop/agent_order/list",//采购单

  //网店库存
  "wms_shop_stock_get_info": baseUrl + "/shop_api/wms/shop_stock/get_info",//获取绑定仓库
  "wms_shop_stock_bind": baseUrl + "/shop_api/wms/shop_stock/bind",//绑定仓库
  "wms_shop_stock_unbind": baseUrl + "/shop_api/wms/shop_stock/unbind",//取消绑定仓库
  "wms_parcels_order_list": baseUrl + "/shop_api/wms/parcels/order/list",//网店订单列表
  "wms_parcels_bill_list": baseUrl + "/shop_api/wms/parcels/bill/list",//发货单列表
  "wms_parcels_bill_detail": baseUrl + "/shop_api/wms/parcels/bill/detail",//发货单详情
  "wms_parcels_bill_create": baseUrl + "/shop_api/wms/parcels/bill/create",//创建发货单
  "wms_parcels_bill_auto_allocate": baseUrl + "/shop_api/wms/parcels/order/auto_allocate",//发货单自动库存分配
  //网店库存 出库单
  "wms_parcels_bill_create_out": baseUrl + "/shop_api/wms/parcels/bill/create_out_bill",//创建出库单
  "wms_parcels_bill_status": baseUrl + "/shop_api/wms/parcels/bill/status_list",//发货单状态列表
  "wms_parcels_bill_send_goods": baseUrl + "/shop_api/wms/parcels/bill/send_goods",//发货
  "wms_parcels_action_merge_data": baseUrl + "/shop_api/wms/parcels/bill/action/get_merge_bill_data",//获取多张发货单信息
  "wms_parcels_action_merge": baseUrl + "/shop_api/wms/parcels/bill/action/merge",//合并
  "wms_parcels_bill_reject": baseUrl + "/shop_api/wms/parcels/bill/action/reject",//驳回发货单

  //打印模板
  "print_page_list": baseUrl + "/shop_api/print_page/list",
  "print_page_delete": baseUrl + "/shop_api/print_page/delete/",
  "print_page_save": baseUrl + "/shop_api/print_page/save",

  "print_spPrint_print": baseUrl + "/shop_api/spPrint/print",//商鹏云打印
  "print_spPrint_list": baseUrl + "/shop_api/spPrint/list",//云打印查找设备
  "print_spPrint_add": baseUrl + "/shop_api/spPrint/add",//云打印绑定设备
  "print_spPrint_delete": baseUrl + "/shop_api/spPrint/delete",//云打印删除设备

  //提现
  "withdraw_list": baseUrl + "/shop_api/withdraw/list",//提现列表
  "withdraw_agree": baseUrl + "/shop_api/withdraw/agree/",//提现审核
  "withdraw_refuse": baseUrl + "/shop_api/withdraw/refuse/",//提现拒绝
  "withdraw_save": baseUrl + "/custom_api/withdraw/save",
  "bindAlipay": baseUrl + "/custom_api/shop_user/set_alipay",//绑定支付宝

  "regionList": baseUrl + "/shop_api/regions/list",//区域列表

  "find_by_sn": baseUrl + "/shop_api/swms/serial_no/find_by_sn",//根据条码查询信息
  "find_sn_by_code": "/shop_api/swms/serial_no/find_sn_by_code", //sn内码查外码
  "get_product_info_by_sn": baseUrl + "/shop_api/tracing_origin/get_product_info_by_sn",//根据sn码查询商品信息
  "find_by_own_sn": baseUrl + "/shop_api/swms/serial_no/find_by_own_sn",//溯源根据店铺条码查询商品信息
  "activate_product": baseUrl + "/shop_api/swms/serial_no/activate_product",
  "get_wxsdk_config": baseUrl + "/shop_api/swms/serial_no/get_wxsdk_config",//获取微信配置

  //扫码溯源
  "save_tracing_origin": baseUrl + "/shop_api/tracing_origin/save",//扫码溯源
  "detail_tracing_origin": baseUrl + "/shop_api/tracing_origin/detail",//扫码溯源详情
  "bind_package_product_barcode": baseUrl + "/shop_api/tracing_origin/bind_product_to_package",
  "bind_package_carton": baseUrl + "/shop_api/tracing_origin/bind_package_to_carton",
  "bind_package_to_user": baseUrl + "/shop_api/tracing_origin/bind_package_to_user",//绑定商品到用户

  "sms_quota_info": baseUrl + "/shop_api/sms/quota/info",//短信配额信息
  "sms_log_list": baseUrl + "/shop_api/sms/log/list",//短信日志列表
  "get_recharge_sms_package_list": baseUrl + "/shop_api/platform_authorize/get_recharge_sms_package_list",//短信充值套餐列表

   //商城到期提醒
   "check_is_alert": baseUrl + "/shop_api/shop_freeze/check_is_alert",//商城到期提醒
   "sure_alert": baseUrl + "/shop_api/shop_freeze/sure_alert",//确认提醒

   //抽佣
   //策略管理
   "strategyDetail": baseUrl + "/shop_api/commission/strategy/getCommissionStrategyDetail", //抽佣策略详情
   "getShopShopAdminStrategyList": baseUrl + "/shop_api/commission/strategy/getShopShopAdminStrategyList", //获取店铺抽佣策略列表
   "strategyList": baseUrl + "/shop_api/commission/strategy/list", //抽佣策略列表
   "strategyCreate": baseUrl + "/shop_api/commission/strategy/create", //抽佣策略创建
   "strategyDelete": baseUrl + "/shop_api/commission/strategy/delete", //删除抽佣策略
   "strategyBindUser": baseUrl + "/shop_api/commission/strategy/bind_user",//用户绑定抽佣策略
   "strategyUnbindUser": baseUrl + "/shop_api/commission/strategy/unbind_user",//用户解绑抽佣策略
   "strategyGetBindUserList": baseUrl + "/shop_api/commission/strategy/get_bind_user_list",//获取抽佣策略绑定用户列表
   "getUserCommissionInfo": baseUrl + "/shop_api/commission/user/getUserCommissionInfo",//获取用户抽佣信息
   "computeCommissionByStrategyId": baseUrl + "/shop_api/commission/compute_commission_by_strategy_id",//计算用户抽佣
   "getStrategyCommissionDetails": baseUrl + "/shop_api/commission/strategy/getStrategyCommissionDetails",//获取策略下用户抽佣详情
   "getAllUsersCommissionInfoByStrategyId":baseUrl + "/shop_api/commission/get_all_users_commission_info_by_strategy_id",
   "getUserAllStrategiesCommissionInfo": baseUrl + "/shop_api/commission/get_user_all_strategies_commission_info",//获取用户所有抽佣信息
   //分类策略管理
   "classStrategyCreate": baseUrl + "/shop_api/commission/class_strategy/create",//分类策略创建
   "classStrategyAddSkuPrice": baseUrl + "/shop_api/commission/class_strategy/addSkuPrice",//添加分类策略SKU价格
   "classStrategyDeleteSkuPrice": baseUrl + "/shop_api/commission/class_strategy/deleteSkuPrice",//删除分类策略SKU价格
   "classStrategyAddSkuPricList": baseUrl + "/shop_api/commission/class_strategy/addSkuPricList",//添加分类策略SKU价格列表
   "classStrategyAddClassStrategy": baseUrl + "/shop_api/commission/class_strategy/addClassStrategy",//添加分类策略
   "classStrategyClassStrategyList": baseUrl + "/shop_api/commission/class_strategy/classStrategyList",//分类策略列表
   "classStrategyAddClass": baseUrl + "/shop_api/commission/class_strategy/addClass",//添加分类策略

   //分账
  "add_shop_user": baseUrl + "/shop_api/share_account/receiver_config/add_shop_user", // 绑定分账商家账户
  "find_by_shop_user": baseUrl + "/shop_api/share_account/receiver_config/find_by_shop_user", // 查询用户已绑定的分账账户
  "receiver_config_delete": baseUrl + "/shop_api/share_account/receiver_config/delete", // 删除分账接收方配置
  "sharing_order_list": baseUrl + "/shop_api/share_account/order_query/list", // 分账订单列表
  "sharing_refund_list": baseUrl + "/shop_api/share_account/order_query/refund_list", // 退账订单列表
  "find_by_refund_no": baseUrl + "/shop_api/share_account/order_query/find_by_refund_no", // 通过退账单号查询
}



// WEBPACK FOOTER //
// ./src/utils/api.js